import * as URLConfig from "@frameworks/salesjourney/config/domain";
import { microService } from "../microServiceBase";
var profileUrlConfig = {
    profileDetails: URLConfig.config.apiBase +
        microService.userService +
        "profile/ProfileDetails",
    profileImageDetails: URLConfig.config.apiBase +
        microService.userService +
        "profile/ProfilePicture",
    creaticalDetails: URLConfig.config.apiBase + microService.leadService + "Leads/Critical",
    postSocialMedia: URLConfig.config.apiBase + microService.userService + "profile/SocialMedia",
    rmRatingDetails: URLConfig.config.apiBase +
        microService.userService +
        "UserRating/RMAdditionalRating",
    rmRatings: URLConfig.config.apiBase + microService.userService + "UserRating/Rating",
    clientRatingSummary: URLConfig.config.apiBase + "userserviceapi/UserRating/ClientRatingSummary",
    clientRatingSummaryNew: URLConfig.config.apiBase +
        microService.userService +
        "userrating/ClientRatingSummary",
    ClientRatingSummaryDetails: URLConfig.config.apiBase +
        microService.userService +
        "userrating/ClientRatingSummaryDetails",
    postProfileImage: URLConfig.config.apiBase + microService.userService + "profile/ProfilePic",
    getOnDeskDetails: URLConfig.config.apiBase +
        microService.userService +
        "profile/OnDeskDetails",
    updateOnDeskDetails: URLConfig.config.apiBase + microService.userService + "profile/ondesk",
    getSocialMediaDetails: URLConfig.config.apiBase +
        microService.userService +
        "profile/SocialMediaDetails",
    getUPCData: URLConfig.config.apiBase + microService.userService + "profile/GetUPC",
    getUserMenu: URLConfig.config.apiBase + microService.userService + "profile/getUserMenu",
    getPrefrence: URLConfig.config.apiBase +
        microService.userService +
        "profile/getPrefrence",
    savePreference: URLConfig.config.apiBase +
        microService.userService +
        "profile/savePrefrence",
    validatefeedback: URLConfig.config.apiBase +
        microService.userService +
        "feedback/validatefeedback",
    addfeedback: URLConfig.config.apiBase +
        microService.userService +
        "feedback/addfeedback",
    documentUpload: URLConfig.config.apiBase +
        microService.userService +
        "absentdata/addAttachement",
    markAbsentee: URLConfig.config.apiBase +
        microService.userService +
        "absentdata/markAbsentee",
    absenteeSampleFile: URLConfig.config.apiBase +
        microService.userService +
        "absentdata/samplefile",
    downloadAbsenteeFile: URLConfig.config.apiBase +
        microService.userService +
        "absentdata/downloadFile",
    getAbsenteeData: URLConfig.config.apiBase +
        microService.userService +
        "absentdata/getAbsentee",
};
export default profileUrlConfig;
